import { render, staticRenderFns } from "./MagicURL.vue?vue&type=template&id=552d9d77&"
import script from "./MagicURL.vue?vue&type=script&lang=ts&"
export * from "./MagicURL.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports